export default "<div class=\"mb-5\">\n    <app-header></app-header>\n</div>\n<router-outlet></router-outlet>\n";